import React from 'react';
import PaginatedPrioritySection from './PaginatedPrioritySection';
import EditableText from './EditableText';

export default function DevelopmentAreasPage({ data, personName, startPageNumber }) {
  const header = (
    <>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        <span className="pdf-section-heading__badge">4</span>
        <EditableText
          as="span"
          path="keyDevelopmentAreas.sectionHeading"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="div"
        className="pdf-body-text"
        path="keyDevelopmentAreas.pagePara"
        variant="block"
      />
    </>
  );

  return (
    <PaginatedPrioritySection
      header={header}
      tableContents={data.tableContents}
      legendKeys={data.legendKeys}
      summaryContentPath="keyDevelopmentAreas.summaryContent"
      slicePageContent="keyDevelopmentAreas"
      sectionKey="keyDevelopmentAreas"
      startPageNumber={startPageNumber}
      personName={personName}
    />
  );
}
